// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "multiCity-3L1ea";
var _4 = "label-kH_Xs";
var _5 = "caption-aA5jW";
var _6 = "input-3M8M3";
export { _1 as "__esModule", _2 as "mobile", _3 as "multiCity", _4 as "label", _5 as "caption", _6 as "input" }
export default { "__esModule": _1, "mobile": _2, "multiCity": _3, "label": _4, "caption": _5, "input": _6 }
